import { render, staticRenderFns } from "./LogReportDue.vue?vue&type=template&id=9bb45808"
import script from "./LogReportDue.vue?vue&type=script&lang=js"
export * from "./LogReportDue.vue?vue&type=script&lang=js"
import style0 from "./LogReportDue.vue?vue&type=style&index=0&id=9bb45808&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports